import clubsService from '~/services/clubService'

export const useClubStore = defineStore('ClubStore', {
  state: () => {
    return {
      clubs: [],
      popularClubs: []
    }
  },
  getters: {},
  actions: {
    async fetch (payload) {
      try {
        const { clubs } = await clubsService.fetch(payload)
        this.clubs = clubs

        return clubs
      } catch (e) {
        console.error('CLUB STORE ERROR:' + e)
      }
    },

    async popular () {
      try {
        const { clubs } = await clubsService.popular()
        this.popularClubs = clubs

        return clubs
      } catch (e) {
        console.error('CLUB STORE ERROR:' + e)
      }
    }
  }
})
